import { useAtom } from 'jotai'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<boolean>(false, MMKVKey.IsAuthorized)

export const useIsAuthorizedAtom = () => useAtom(atom)
export const useResetIsAuthorizedAtom = () => useAtom(resetAtom)
